import { Col, Row, Modal, Input, Form, message } from "antd";
import Title from "../Title/Title";
import { useState, useEffect } from "react";
import "./style.css";
import { CheckPassword } from "./Checkpassword";
import { useMutation } from "react-query";
import { changeUserPassword, changeUserPasswordAdmin } from "../../../api/users";
import { useTranslation } from "react-i18next";
import { getIsComplexPassword } from "../../../utils/main-utils";
import { CheckPasswordSimple } from "./CheckPasswordSimple";

type propsType = {
  openpassword: boolean;
  setOpenpassword: React.Dispatch<React.SetStateAction<boolean>>;
  show: boolean;
  id?: number;
  requireOldPassword: boolean;
};
export const Password = ({
  openpassword,
  setOpenpassword,
  show,
  id,
  requireOldPassword,
}: propsType) => {
  const [t] = useTranslation("common");
  const [password, setPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [capital, setCapital] = useState(false);
  const [number, setNumber] = useState(false);
  const [special, setSpecial] = useState(false);
  const [space, setSpace] = useState(false);
  const [checkedPassword, setCheckedPassword] = useState(false);
  const [allTrue, setAllTrue] = useState(false);
  const [mustinclude, SetMustInclude] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('')

  var strongRegex = new RegExp(`^.{8,}`);
  var strongRegexSimplePassword = new RegExp(`^.{4,}`);
  var stRegex = new RegExp(`^(?=.*[A-Z])`);
  var numRegex = new RegExp(`(?=.*[0-9])`);
  var speRegex = new RegExp(`^(?=.*[!@#$%^&*.+-/])`);
  var spaces = new RegExp(`^(?!.* )`);

  useEffect(() => {
    setAllTrue(false)
  }, [])

  useEffect(() => {
    if (getIsComplexPassword()) {
      setAllTrue(
        password && capital && number && special && space && checkedPassword
      );
    } else {
      setAllTrue(
        password && checkedPassword
      );
    }

  }, [password, capital, number, special, space, checkedPassword]);

  useEffect(() => {
    if (getIsComplexPassword()) {
      SetMustInclude(password && capital && number && special && space);
    } else {
      SetMustInclude(password)
    }
  }, [password, capital, number, special, space]);

  const handlePasswordChange = (e: any) => {
    if (getIsComplexPassword()) {
      setPassword(strongRegex.test(e.target.value));
      setCapital(stRegex.test(e.target.value));
      setNumber(numRegex.test(e.target.value));
      setSpecial(speRegex.test(e.target.value));
      setSpace(spaces.test(e.target.value));
    } else {
      setPassword(strongRegexSimplePassword.test(e.target.value));
    }
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordInput = (e: any) => {
    setConfirmPassword(e.target.value)
  }

  const { mutate: changePasswordMutation, isLoading } = useMutation(
    "changePassword",
    changeUserPassword,
    {
      onSuccess: ({ data }) => {
        setOpenpassword(false)
        message.success(data.message)
      },
      onError: ({ response }) => {
        setOpenpassword(true)
        message.error(response.data.message)
      }
    }
  );

  const { mutate: changePasswordAdminMutation, isLoading: isLLoading } = useMutation(
    "changePasswordAdmin",
    changeUserPasswordAdmin,
    {
      onSuccess: ({ data }) => {
        setOpenpassword(false)
        message.success(data.message)
      },
      onError: ({ response }) => {
        setOpenpassword(true)
        message.error(response.data.message)
      }
    }
  );

  const [form] = Form.useForm();

  const handleChangePassword = () => {
    // if (allTrue && !(form.getFieldValue("currentPassword") && form.getFieldValue("newpassword") && form.getFieldValue("currentPassword") !== form.getFieldValue("newpassword"))) return
    const currentPassword = form.getFieldValue("currentPassword")
    const newPassword = form.getFieldValue("newpassword");
    if (requireOldPassword) {
      changePasswordMutation({ currentPassword: currentPassword, newPassword: newPassword, isComplex: getIsComplexPassword() });
    }
    else {
      changePasswordAdminMutation({ id: id, newPassword: newPassword, isComplex: getIsComplexPassword() });
    }
  };

  useEffect(() => {
    setCheckedPassword(newPassword === confirmPassword && newPassword.length > 0)
  }, [newPassword, confirmPassword])

  // useEffect(() => {
  //   console.log('password', password)
  //   console.log('capital', capital)
  //   console.log('number', number)
  //   console.log('special', special)
  //   console.log('space', space)
  //   console.log('checkedPassword', checkedPassword)
  //   console.log('allTrue', allTrue)
  //   console.log('mustinclude', mustinclude)
  //   console.log('------------------------')
  // }, [password, capital, number, special, space, checkedPassword, allTrue, mustinclude])

  return (
    <Modal
      closable={false}
      maskClosable={false}
      width={600}
      okButtonProps={{
        style: {
          height: "40px",
          background: !allTrue || (requireOldPassword && !form.getFieldValue("currentPassword")) || !form.getFieldValue("newpassword") || form.getFieldValue("currentPassword") === form.getFieldValue("newpassword") ? "gray" : "#1677FF",
          color: "#fff",
          width: "100px",
        },
        disabled: !allTrue || (requireOldPassword && !form.getFieldValue("currentPassword")) || !form.getFieldValue("newpassword") || form.getFieldValue("currentPassword") === form.getFieldValue("newpassword")
      }}
      cancelButtonProps={{
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      }}
      cancelText={t("cancel")}
      centered
      onCancel={() => setOpenpassword(false)}
      onOk={handleChangePassword}
      okText={isLoading || isLLoading ? "Loading..." : `${t("save")}`}
      open={openpassword}
      destroyOnClose={true}
    >
      <Form layout="vertical" form={form}>
        <Row>
          <Col offset={1}>
            <Title title={`${t("change-password")}`} />
          </Col>
          <Col
            offset={1}
            span={23}
            className="modaltitleEdit"
            style={{ marginBottom: "20px" }}
          >
            {t("please-confirm-old-password-and-enter-new")}
          </Col>
        </Row>
        <Row>
          <Col offset={1} span={12}>
            {show ? (
              <Form.Item
                label={t("old-password").replace(/:/g, "")}
                name="currentPassword"
              >
                <Input
                  autoComplete="new-password"
                  placeholder={`${t("enter-text")}`}
                />
              </Form.Item>
            ) : null}
            <Form.Item label={t("new-password")} name="newpassword">
              <Input.Password
                placeholder={`${t("enter-text")}`}
                onChange={handlePasswordChange}
                autoComplete="new-password"
              />
            </Form.Item>
            <Form.Item
              label={`${t("confirm-new-password")}`.replace(/:/g, "")}
              name="confirmpassword"
            >
              <Input.Password
                autoComplete="new-password"
                placeholder={`${t("enter-text")}`}
                onChange={handleConfirmPasswordInput}
              />
            </Form.Item>
            {getIsComplexPassword() ?
              <CheckPassword
                password={password}
                capital={capital}
                number={number}
                special={special}
                space={space}
                checkedPassword={checkedPassword}
                allTrue={allTrue}
                mustinclude={mustinclude}
              /> : <CheckPasswordSimple
                password={password}
                checkedPassword={checkedPassword}
                allTrue={allTrue}
              />}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
